import React from 'react'
import { Prohibit } from '@phosphor-icons/react'
import { dangerBannerClass, bannerTextStyle } from '@/lib/styleKit'
import { cn } from '@/lib/utils'
import type { ApprovalInfo } from '@/types/approvals'

/**
 * "Rejected by X: reason", shown to the Rep on a rejected workflow (builder)
 * or campaign (detail page) so they know what to fix before resubmitting
 * (brief C5). Renders nothing unless the latest approval record is a
 * rejection.
 */
const RejectionBanner: React.FC<{ approval?: ApprovalInfo | null; className?: string }> = ({ approval, className }) => {
  if (!approval || approval.status !== 'rejected') return null
  const who = approval.decided_by_name || approval.approver_name || 'An approver'
  return (
    <div className={cn(dangerBannerClass, className)} role="status" data-testid="rejection-banner">
      <Prohibit className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" weight="fill" />
      <div style={bannerTextStyle}>
        <span style={{ fontWeight: 590 }}>Rejected by {who}</span>
        {approval.reason ? <span>: {approval.reason}</span> : null}
        {approval.decided_at && (
          <span className="opacity-80"> ({new Date(approval.decided_at).toLocaleString()})</span>
        )}
      </div>
    </div>
  )
}

export default RejectionBanner
